<script setup>
import SaveForLater from '@/components/Offcanvas/SaveForLater.vue';

const imgNoAvatar = new URL('@/assets/svg/icons/no-avatar.svg', import.meta.url).href;
const imgHeart = new URL('@/assets/svg/icons/heart.svg', import.meta.url).href;

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  body: {
    type: String,
    default: '',
  },
  avatar: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  expertise: {
    type: String,
    required: true,
  },
  saveForLater: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const imgAvatar = props.avatar === '' ? imgNoAvatar : props.avatar;
</script>

<template>
  <div class="virtual-assistant">
    <div class="row">
      <div class="col-12">
        <h2 v-if="title.length > 0">
          {{ title }}
        </h2>

        <p v-if="body.length > 0">
          {{ body }}
        </p>
      </div>
    </div>
    <div class="row d-flex justify-content-around">
      <div class="col-auto small d-flex align-items-center flex-grow-1 mt-2">
        <img
          class="specialist"
          :src="imgAvatar"
          alt="Product specialist"
        >
        <strong>{{ name }}</strong> {{ $t('virtual-assistant.general.productSpecialist', { expertise: expertise }) }}
      </div>
      <div
        v-if="saveForLater"
        class="col-auto small ms-auto d-flex align-items-center"
      >
        <BaseButton
          :white="true"
          :left-skew="true"
          :left-skew-inverse="true"
          :right-skew="false"
          :right-skew-inverse="false"
          :full-width="true"
          data-bs-toggle="offcanvas"
          data-bs-target="#saveForLater"
        >
          <img
            :src="imgHeart"
            alt="heart"
          >
          {{ $t('general.callToActionButton.saveForLater') }}
        </BaseButton>
        <SaveForLater />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.virtual-assistant {
  margin-left: calc(var(--bs-gutter-x) * -0.5);
  margin-right: calc(var(--bs-gutter-x) * -0.5);
  padding: 1.6rem var(--bs-gutter-x) 2.4rem;
  background-color: var(--ux-colors-white);

  h2 {
    font-size: 2.4rem;
    margin-bottom: 0.5rem;
    @include media-breakpoint-up(lg) {
      padding-bottom: 0.5rem;
      font-size: 3rem;
      border-bottom: solid 1px var(--ux-colors-black-30);
    }
  }

  p {
    padding-bottom: 1.6rem;
    margin-bottom: 0;
  }

  .specialist {
    padding-right: 0.8rem;
    max-height: 4rem;
    max-width: 4rem;
  }

  .formkit-outer {
    margin: 0;
  }

  @include media-breakpoint-up(lg) {
    background-color: unset;
    padding: 1.6rem calc(var(--bs-gutter-x) * 0.5) 2.4rem;
  }
}
</style>
